import {
  FEEDBACKS_GET,
  FEEDBACK_EDIT,
  FEEDBACK_GET,
  FEEDBACK_DELETE,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
};

const feedbacksGet = (state, payload) => {
  const feedbacks = payload.feedbacks;
  return {
    ...state,
    total: feedbacks.total,
    items: [...feedbacks.items],
    search: { ...feedbacks.search },
  };
};

const feedbackEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.feedback.id + ''),
      payload.feedback,
    ],
  };
};

const feedbackGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.feedback.id + ''),
      payload.feedback,
    ],
  };
};

const feedbackDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.feedback.id + ''),
    ],
  };
};

export default createReducer(initialState, {
  [FEEDBACKS_GET]: feedbacksGet,
  [FEEDBACK_EDIT]: feedbackEdit,
  [FEEDBACK_GET]: feedbackGet,
  [FEEDBACK_DELETE]: feedbackDelete,
});
